import React, { useRef } from "react";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";
import { VariableSelector } from "./VariableSelector";

interface TemplateTextAreaProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  description?: string;
  placeholder?: string;
  className?: string;
  actions?: React.ReactNode;
  hideVariableSelector?: boolean;
}

export const TemplateTextArea: React.FC<TemplateTextAreaProps> = ({
  value,
  onChange,
  label,
  description,
  placeholder,
  className,
  actions,
  hideVariableSelector = false,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleVariableSelect = (variable: string) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const newValue =
      value.substring(0, start) + variable + value.substring(end);

    onChange(newValue);

    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(
        start + variable.length,
        start + variable.length,
      );
    }, 0);
  };

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <Textarea
        ref={textareaRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        description={description}
        placeholder={placeholder}
        className="min-h-28 resize-y"
      />
      {!hideVariableSelector || actions ? (
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center">
            {!hideVariableSelector && (
              <VariableSelector onSelect={handleVariableSelect} />
            )}
          </div>
          {actions ? <div>{actions}</div> : null}
        </div>
      ) : null}
    </div>
  );
};
